<script lang="ts">
	import Table from '#lib/components/Table.svelte';
	import _ from 'lodash';
	import type {
		HDFieldPlayer,
		HDGameReportResponseData,
		HDGoal
	} from '../types/responses/GameReport.js';
	import type { HDExtraData } from '../types/util/ExtraData.js';
	import CollapsibleCard from '#lib/components/CollapsibleCard.svelte';

	let {
		game
	}: {
		game: HDGameReportResponseData;
	} = $props();

	let goalsCols = $state([
		{
			key: 'gameTimePeriod',
			label: 'Per',
			sortable: true,
			tooltip: 'Spielabschnitt',
			tooltipClass: 'tooltip-right'
		},
		{
			key: 'gameTimeFormatted',
			label: 'Zeit',
			sortable: true
		},
		{
			key: 'newScore',
			label: 'Score'
		},
		{
			key: 'gameStrength',
			label: 'GS',
			sortable: true,
			tooltip: 'Spielstärke'
		},
		{
			key: 'extraData.team',
			label: 'Team',
			sortable: true
		},
		{
			key: 'scorer',
			label: '',
			sortable: true,
			sortFunction: (o: HDExtraData<HDFieldPlayer>) => `${o.playerLastname} ${o.playerFirstname}`,
			class: 'justify-start'
		},
		{
			key: 'assist1',
			label: '',
			sortable: true,
			sortFunction: (o: HDExtraData<HDFieldPlayer>) => `${o.playerLastname} ${o.playerFirstname}`,
			class: 'justify-start'
		},
		{
			key: 'assist2',
			label: '',
			sortable: true,
			sortFunction: (o: HDExtraData<HDFieldPlayer>) => `${o.playerLastname} ${o.playerFirstname}`,
			class: 'justify-start'
		},
		{
			key: 'goalInfo',
			label: ''
		}
	]);

	let goals = $derived.by(() =>
		game
			? [
					...game.homeGoals.map(
						(goal: HDGoal): HDExtraData<HDGoal> => ({
							id: goal.guid,
							extraData: {
								team: game.gameData.homeTeamShortname
							},
							...goal
						})
					),
					...game.awayGoals.map(
						(goal: HDGoal): HDExtraData<HDGoal> => ({
							id: goal.guid,
							extraData: {
								team: game.gameData.awayTeamShortname
							},
							...goal
						})
					)
				].sort((a, b) => a.gameTime - b.gameTime)
			: []
	);
</script>

<CollapsibleCard title="Tore" open>
	<Table columns={goalsCols} rows={goals} error="!!error">
		{#snippet headers(column)}
			{#if column.key === 'scorer'}
				<div class="flex flex-row items-center">
					<span class="text-accent block w-8 pr-2 text-right">#</span> Torschütze
				</div>
			{:else if column.key === 'assist1'}
				<div class="flex flex-row items-center">
					<span class="text-accent block w-8 pr-2 text-right">#</span> Assist 1
				</div>
			{:else if column.key === 'assist2'}
				<div class="flex flex-row items-center">
					<span class="text-accent block w-8 pr-2 text-right">#</span> Assist 2
				</div>
			{:else}
				<div>{column.label}</div>
			{/if}
		{/snippet}

		{#snippet data(row, col, getRowData)}
			{#if col.key === 'newScore'}
				<div>{row.newScore}</div>
			{:else if col.key === 'goalInfo'}
				{#if row.isGameWinningGoal}
					<span class="bg-neutral border-accent mx-2 border-2 px-2 py-1 text-sm">GWG</span>
				{:else if row.isEmptyNet}
					<span class="bg-neutral border-accent mx-2 border-2 px-2 py-1 text-sm">EN</span>
				{:else if row.isPenaltyShot}
					<span class="bg-neutral border-accent mx-2 border-2 px-2 py-1 text-sm">PS</span>
				{:else}
					<span></span>
				{/if}
			{:else if col.key === 'scorer'}
				<div class="flex flex-row items-center">
					<span class="text-accent block w-8 pr-2 text-right">{row.scoredBy.playerJerseyNr}</span>
					{row.scoredBy.playerLastname}&nbsp;{row.scoredBy.playerFirstname.charAt(0)}
				</div>
			{:else if col.key === 'assist1'}
				{#if row.assistBy}
					<div class="flex flex-row items-center">
						<span class="text-accent block w-8 pr-2 text-right">{row.assistBy.playerJerseyNr}</span>
						{row.assistBy.playerLastname}&nbsp;{row.assistBy.playerFirstname.charAt(0)}.
					</div>
				{/if}
			{:else if col.key === 'assist2'}
				{#if row.assist2By}
					<div class="flex flex-row items-center">
						<span class="text-accent block w-8 pr-2 text-right"
							>{row.assist2By?.playerJerseyNr}</span
						>
						{row.assist2By?.playerLastname}&nbsp;{row.assist2By?.playerFirstname.charAt(0)}.
					</div>
				{/if}
			{:else}
				{getRowData(row, col.key)}
			{/if}
		{/snippet}
	</Table>
</CollapsibleCard>
